import { render, staticRenderFns } from "./ViewerSideBar.vue?vue&type=template&id=3ca08a14&"
import script from "./ViewerSideBar.vue?vue&type=script&lang=js&"
export * from "./ViewerSideBar.vue?vue&type=script&lang=js&"
import style0 from "./ViewerSideBar.vue?vue&type=style&index=0&id=3ca08a14&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports